import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenu from '@core/layouts/layout-vertical/components/vertical-nav-menu/useVerticalNavMenu'

const { t } = useI18nUtils()

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  render(h) {
  // Pass props to composable
    const menu = useVerticalNavMenu()

    // Compute if header should be visible
    const isshow = menu.isVerticalMenuCollapsed.value && !menu.isMouseHovered.value
    const hasBorder = this.item.header !== 'Dashboards'

    const span = h(
      'span',
      {
        style: {
          backgroundColor: this.item.backgroundColor || '#ffff',
          color: this.item.color || '#434343',
          display: !isshow ? 'block' : 'none',
          borderRadius: '4px',
          marginLeft: '11%',
          marginRight: '2%',
          marginTop: '8px',
          width: '80%',
          fontSize: '12px',
          fontWeight: 500,
          paddingTop: hasBorder ? '1.25rem' : '0.5rem',
          borderTop: hasBorder ? '1px solid #D9D9D9' : 'none',
        },
      },
      t(this.item.header),
    )

    // Create the icon element
    const icon = h('feather-icon', {
      props: { icon: 'MoreHorizontalIcon', size: '18' },
      style: { marginLeft: '0.5rem' },
    })

    // Return the li element containing span and icon
    return h(
      'li',
      {
        class: 'navigation-header d-flex align-items-center',
        style: {
          margin: '0.5rem 0',
        },
      },
      [span, icon],
    )
  },
}
